module.exports = __webpack_public_path__ + "static/media/CeraPro-Light.12d9a402.ttf";